// --------------------------------------------------------------
// Created On: 2021-05-14
// Author: Zachary Thomas
//
// Last Modified: 2025-10-27
// Modified By: Zachary Thomas
//
// Copyright 2024 - 2025 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import styles from "./NavbarLink.module.scss";

// A single clickable link on a navbar.
export default function NavbarLink(props: Props): Component {
  const [targetPage, setTargetPage] = useState<string | undefined | null>("");

  // Treat partial matches as complete matches, unless exact is enabled.
  useEffect(() => {
    if (props.exactMatch) {
      setTargetPage(props.targetPage);
    } else {
      if (props.targetPage === undefined || props.targetPage === null) {
        setTargetPage(props.currentPage);
      } else if (props.targetPage !== null && props.targetPage !== undefined) {
        const targetPageArray = props.targetPage.split("/");
        const currentPageArray = props.currentPage.split("/");

        let pathMatch = true;
        currentPageArray.forEach((subdirectory, i) => {
          if (targetPageArray[i] !== subdirectory) {
            pathMatch = false;
          }
        });

        if (pathMatch) {
          setTargetPage(props.currentPage);
        } else {
          setTargetPage(props.targetPage);
        }
      }
    }
  }, [props.currentPage, props.targetPage, props.exactMatch]);

  return (
    <li className={`${styles.item} mx-3 ${targetPage === props.currentPage ? styles.active : ""}`}>
      <Link className={styles.link} to={targetPage ? targetPage : props.currentPage}>
        <span>{props.name}</span>
      </Link>
    </li>
  );
}

interface Props {
  name: string;
  currentPage: string;
  targetPage?: string;
  exactMatch?: boolean;
}
